import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";

const MultiSelectCreatableOption = (props) => {
  const dispatch = useDispatch();
  const normalizeValue = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    // Handle single object with label and value
    if (typeof val === 'object' && val.label && val.value) {
      return [val];
    }
    // Handle string values
    if (typeof val === 'string' && val.trim() !== '') {
      return [{ label: val, value: val }];
    }
    return [];
  };
  
  const [selected, setSelected] = useState(() => normalizeValue(props.value));
  const [options, createOption] = useState([]);
  const avilableOptions = props.avilableOptions;
  const [disabled, setdisabled] = useState(props.disabled);
  const newExtendhierarchy = useSelector(
    (state) => state.project.extendNewHierarchy
  );
  
  const shouldTriggerOnChange = () => {
    // Non-modal fields should always be able to trigger onChange
    if (props.extendModal === false) {
      return true;
    }
    // Modal fields should only trigger onChange when hierarchy is not saved yet
    return selected.length > 0 && newExtendhierarchy.saved !== true;
  };

  const shouldSyncValue = () => {
    // Always sync for non-modal fields
    if (props.extendModal === false) {
      return true;
    }
    // For modal fields, sync when hierarchy is saved
    return newExtendhierarchy.saved && !props.reset;
  };
  useEffect(() => {
    async function createOptionArray() {
      let optionArray = [];
      avilableOptions &&
        avilableOptions?.map((item) =>
          optionArray.push({
            label: item.label ? item.label : item,
            value: item.value ? item.value : item,
            disabled: item.disabled ? item.disabled : false,
          })
        );
      createOption(optionArray);
    }
    if (avilableOptions) {
      createOptionArray();
    }
  }, [avilableOptions, dispatch]);

  useEffect(() => {
    if (props.reset || !props.value) {
      setSelected([]);
    } else if (shouldSyncValue()) {
      setSelected(normalizeValue(props.value));
    }
  }, [props.value]);

  useEffect(() => {
    if (shouldTriggerOnChange()) {
      props.onChange(selected);
    }
  }, [selected, dispatch]);

  const handleNewField = (value) => ({
    label: value,
    value: value,
  });

  const customValueRenderer = (selected, _options) => {
    return selected.length
      ? selected.map(({ label }) => label).join(", ")
      : props.label;
  };
  const singleRenderer = (selected) => {
    return selected.length ? selected[selected.length-1].value : props.label;
  };

  const handleSelectChange = (updatedSelected) => {
    const nextSelected = props.hasSelectAll
      ? updatedSelected
      : (updatedSelected.length ? [updatedSelected[updatedSelected.length - 1]] : updatedSelected);

    setSelected(nextSelected);

    if (!nextSelected.length) {
      props.onChange?.([]);
    }
  };

  return (
    <div data-testid="MultiselectCreate" style={{ flex: 1, minWidth: 0, maxWidth: '100%' }}>
      <MultiSelect
        className={`decarb-multiselect`}
        options={options}
        value={selected}
        valueRenderer={
          props.hasSelectAll ? customValueRenderer : singleRenderer
        }
        onChange={handleSelectChange}
        labelledBy={props.label}
        isCreatable={props.isCreatable}
        onCreateOption={handleNewField}
        overrideStrings={props.overrideStrings}
        disabled={props.disabled}
        hasSelectAll={props.hasSelectAll}
        closeOnChangedValue={true}
      />
    </div>
  );
};

export default MultiSelectCreatableOption;
